import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { HttpHelper } from '@app/core/helpers/http.hepler';
import { IPlaceApiV5Model, IUserApiModel } from '@app/core/models/api';
import { IProfileApiModel } from '../models/api/profile.api.model';
import { ProfileModel } from '../models/profile.model';
import { UserModel } from '../models/user.model';

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  getUserFacebook(): Observable<{
    user: IUserApiModel;
    profile: IProfileApiModel;
  }> {
    return this.http.get<{ user: IUserApiModel; profile: IProfileApiModel }>(
      `${environment.API_URL}v5/user.json`,
    );
  }

  signIn(phoneVal: string): Observable<{ success: boolean }> {
    const formData = new FormData();

    formData.append('submission_handler', 'user.login');
    formData.append('phone', phoneVal);
    return this.http.post<{ success: boolean }>(
      `${environment.API_URL}v5/`,
      formData,
      {
        headers: HttpHelper.setHeaders(),
      },
    );
  }

  signUp(
    phoneVal: string,
    name: string,
    lastName: string,
  ): Observable<HttpResponse<{ success: boolean; user: IUserApiModel }>> {
    const formData = new FormData();

    formData.append('submission_handler', 'user.register');
    formData.append('phone', phoneVal);
    formData.append('first_name', name);
    formData.append('last_name', lastName);
    return this.http.post<{ success: boolean; user: IUserApiModel }>(
      `${environment.API_URL}v5/`,
      formData,
      {
        headers: HttpHelper.setHeaders(),
        observe: 'response',
      },
    );
  }

  verify(
    phoneVal: string,
    code: string,
  ): Observable<HttpResponse<{ success: boolean; user: IUserApiModel }>> {
    const formData = new FormData();

    formData.append('submission_handler', 'user.verify');
    formData.append('phone', phoneVal);
    formData.append('code', code);
    return this.http.post<{ success: boolean; user: IUserApiModel }>(
      `${environment.API_URL}v5/`,
      formData,
      {
        headers: HttpHelper.setHeaders(),
        observe: 'response',
      },
    );
  }

  logout(): Observable<any> {
    const formData = new FormData();
    formData.append('submission_handler', 'user.logout');
    return this.http.post(`${environment.API_URL}v5/`, formData, {
      headers: HttpHelper.setHeaders(),
    });
  }

  addBookmark(id): Observable<any> {
    const formData = new FormData();

    formData.append('submission_handler', 'beacon.bookmark');
    formData.append('beacon', id);
    return this.http.post(`${environment.API_URL}v5/`, formData, {
      headers: HttpHelper.setHeaders(),
    });
  }

  removeBookmark(id): Observable<any> {
    const formData = new FormData();

    formData.append('submission_handler', 'beacon.unbookmark');
    formData.append('beacon', id);
    return this.http.post(`${environment.API_URL}v5/`, formData, {
      headers: HttpHelper.setHeaders(),
    });
  }

  getBookmarks(cluster?: number): Observable<Array<IPlaceApiV5Model>> {
    let params = new HttpParams();
    if (cluster) {
      params = params.append('cluster', `${cluster}`);
    }

    return this.http.get<Array<IPlaceApiV5Model>>(
      `${environment.API_URL}v5/bookmarks.json`,
      { params },
    );
  }

  getUser(): Observable<{ user: UserModel; profile: ProfileModel }> {
    const params = new HttpParams()
      // .append('user', `${user}`)
      .append('with_bookmarks', '1')
      // .append('with_all_coupons', '1')
      .append('with_tickets', '1');

    return this.http
      .get<{ user: IUserApiModel; profile: IProfileApiModel }>(
        `${environment.API_URL}v5/user.json`,
        {
          params,
        },
      )
      .pipe(
        map(res => ({
          user: new UserModel(res.user),
          profile: new ProfileModel(res.profile),
        })),
      );
  }
}
